import React, { useState, Fragment } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Cart } from './Cart';
interface MenuItem {
  title: string;
  url: string;
  children?: MenuItem[];
}
const menuItems: MenuItem[] = [{
  title: 'Home',
  url: '/'
}, {
  title: 'Shop All',
  url: '/shop/',
  children: [{
    title: 'Daedo PSS Systems',
    url: '/shop/daedo-pss-system/'
  }, {
    title: 'Daedo Products',
    url: '/shop/daedo-products/'
  }, {
    title: 'Wacoku Products',
    url: '/shop/wacoku-products/'
  }]
}, {
  title: 'Gen 3',
  url: '/shop/gen-3/'
}, {
  title: 'Support',
  url: 'https://www.daedosupport.com/portal/en/home',
  children: [{
    title: 'Thresholds/Hit Levels',
    url: '/thresholds'
  }, {
    title: 'Download Scoring Software',
    url: '/download'
  }, {
    title: 'Troubleshooting Video',
    url: '/daedo-truescore-troubleshooting-video'
  }, {
    title: 'E-Foot Usage Recommendations',
    url: '/E-Footgear_Usage_Recommendations'
  }]
}, {
  title: 'Financing',
  url: '/Financing.html'
}];
const isExternalUrl = (url: string) => /^https?:\/\//i.test(url);
const isHighlighted = (item: MenuItem) => item.title === 'Gen 3';
/**
 * Mobile-only header controls: cart icon + menu toggle, plus the collapsible
 * navigation panel. Menu data is self-contained in this file and is not
 * shared with DesktopMenu.
 */
export function MobileMenu() {
  const [open, setOpen] = useState(false);
  return <>
      {/* Mobile trigger row (cart + hamburger) */}
      <div className="lg:hidden flex items-center space-x-4" data-id="element-91">
        <Cart variant="mobile" data-id="element-92" />
        <button type="button" onClick={() => setOpen(v => !v)} className="text-gray-600 hover:text-gray-900 focus:outline-none" aria-label="Toggle menu" aria-expanded={open} data-id="element-93">
          {open ? <XIcon className="w-6 h-6" data-id="element-94" /> : <MenuIcon className="w-6 h-6" data-id="element-95" />}
        </button>
      </div>

      {/* Collapsible mobile nav panel */}
      {open && <div className="lg:hidden bg-white border-t border-gray-100 absolute w-full shadow-lg left-0" data-id="element-96">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-97">
            {menuItems.map(item => {
          const external = isExternalUrl(item.url);
          const highlight = isHighlighted(item);
          return <Fragment key={item.title} data-id="element-98">
                  <a href={item.url || undefined} {...external ? {
              target: '_blank',
              rel: 'noopener noreferrer'
            } : {}} className={`block px-3 py-3 rounded-md text-base font-bold uppercase tracking-wide ${highlight ? 'text-red-600 bg-red-50' : 'text-gray-900 hover:bg-gray-50'}`} data-id="element-99">
                    {item.title}
                  </a>

                  {item.children?.map(child => {
              const childExternal = isExternalUrl(child.url);
              return <a key={child.title} href={child.url || undefined} {...childExternal ? {
                target: '_blank',
                rel: 'noopener noreferrer'
              } : {}} className="block px-3 py-3 rounded-md pl-8 text-sm normal-case font-semibold text-gray-600 hover:bg-gray-50" data-id="element-100">
                        {child.title}
                      </a>;
            })}
                </Fragment>;
        })}
          </div>
        </div>}
    </>;
}